import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getPuppies = (status) =>
  api.get("/puppies", { params: status ? { status } : {} }).then((r) => r.data);
export const getPuppy = (id) => api.get(`/puppies/${id}`).then((r) => r.data);
export const getLitters = () => api.get("/litters").then((r) => r.data);
export const getReviews = () => api.get("/reviews").then((r) => r.data);
export const getSquareConfig = () => api.get("/square/config").then((r) => r.data);
export const getPaymentsConfig = () => api.get("/payments/config").then((r) => r.data);
export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const chargePayment = (payload) =>
  api.post("/payments/square/charge", payload).then((r) => r.data);
